import { render, staticRenderFns } from "./DesignReview.vue?vue&type=template&id=93d4ea0c&"
import script from "./DesignReview.vue?vue&type=script&lang=js&"
export * from "./DesignReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports